
















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Actions, FormModes, Mutations } from '@/ts/store/Constants';
import FlatTabs from '@/components/Tabs/FlatTabs.vue';
import Avatar from '@/components/Media/Avatar.vue';
import EventAttendees from '@/ts/EventAttendees';

@Component({
    components: {
        FlatTabs,
        Avatar,
    },
})
export default class Attendees extends Vue {
    @Prop({ default: 'create' }) public mode: string;

    public activeTab: string = 'attending';

    get tabs() {
        return [
            {
                title: `${this.$t('general.attending', 'Attending')} (${this.attendees.length})`,
                value: 'attending',
            },
            {
                title: `${this.$t('general.declined', 'Declined')} (${this.decliners.length})`,
                value: 'declined',
            },
            {
                title: `${this.$t('general.no-reply', 'No reply')} (${this.noRepliers.length})`,
                value: 'no-reply',
            },
        ];
    }

    get isEditing(): boolean {
        return this.mode === FormModes.Edit;
    }

    get isCreating(): boolean {
        return this.mode === FormModes.Create;
    }

    get recipients(): EventAttendees[] {
        return this.$store.getters['Events/getAttendees'];
    }

    get attendees(): EventAttendees[] {
        return this.recipients.filter((attendee: EventAttendees) => attendee.answer);
    }

    get decliners(): EventAttendees[] {
        return this.recipients.filter((attendee: EventAttendees) => attendee.answer === 0);
    }

    get noRepliers(): EventAttendees[] {
        return this.recipients.filter((attendee: EventAttendees) => attendee.answer === null);
    }

    get filteredAttendees(): EventAttendees[] {
        if (this.activeTab === 'attending') {
            return this.attendees;
        }

        if (this.activeTab === 'declined') {
            return this.decliners;
        }

        if (this.activeTab === 'no-reply') {
            return this.noRepliers;
        }
    }

    public toggleData(tab: string) {
        this.activeTab = tab;
    }

    public close(): void {
        this.isEditing
            ? this.$store.commit(Mutations.HIDE_EDIT_EVENT_FORM)
            : this.$store.dispatch(Actions.HIDE_FORM);
    }

}
